// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"bb947851","306":"5951d419","322":"eb52217f","453":"8a491834"}[chunkId] + ".chunk.js";
};